<template>
	<div class="mt-1 flex flex-col">
		<p
			class="text-md text-primary text-headerTitle mb-3 max-h-0 overflow-hidden px-5 text-center transition"
			:class="{
				' max-h-[200px] after:relative after:block': !collapsed,
			}"
		>
			<slot />
		</p>
		<div
			class="margin my-0 mx-auto block flex grow basis-1/2 border-b border-dashed border-white lg:hidden"
			@click="collapsed = !collapsed"
		>
			<span class="text-headerTitle block text-[13px] font-bold uppercase lg:mb-4">
				{{ text || 'Helpful tips' }}
			</span>
			<span>
				<ChevronDownSvg
					class="m-auto box-content h-5 w-5 rotate-180 cursor-pointer fill-white transition"
					:class="{ 'rotate-0': collapsed }"
				/>
			</span>
		</div>
	</div>
</template>

<script lang="ts" setup>
	import ChevronDownSvg from './icons/ChevronDownSvg.vue'
	import { ref } from 'vue'
	import { EVENT_BUS_EVENTS, useEventBus } from '../../../stores/eventBus'

	defineProps<{ text?: string }>()
	const collapsed = ref(true)
	const eventBus = useEventBus()

	eventBus.$onAction(({ args }) => {
		if (args[0].name === EVENT_BUS_EVENTS.COLLAPSE_WHY_WE_ASK) collapsed.value = true
	})
</script>
